<template>
  <div class="record_type">
    <div v-for="(item, index) in data" :key="index" class="tag" @click="checkType(item)">
      <van-tag v-if="item.disabled" size="medium">{{ item.title }}</van-tag>
      <div v-else class="">
        <van-tag v-if="selected == item.value" size="medium" :color="checkColor">{{ item.title }}</van-tag>
        <van-tag v-else size="medium" plain>{{ item.title }}</van-tag>
      </div>
    </div>
  </div>
</template>

<script>
import { Tag } from 'vant'

export default {
  name: 'RecordType',
  model: {
    prop: 'value',
    event: 'change'
  },
  components: {
    [Tag.name]: Tag
  },
  props: {
    value: {
      type: Number
    },
    types: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      selected: 0,
      data: [
        { value: 7, title: '晨脉卡', disabled: false },
        { value: 8, title: '体重卡', disabled: false },
        { value: 1, title: '早餐卡', disabled: false },
        { value: 2, title: '午餐卡', disabled: false },
        { value: 3, title: '晚餐卡', disabled: false },
        { value: 4, title: '加餐卡', disabled: false },
        { value: 5, title: '跑步卡', disabled: false },
        { value: 6, title: '技术/力量训练卡', disabled: false }
      ],
      checkColor: '#f2826a'
    }
  },
  watch: {
    types (value) {
      this.initType()
    }
  },
  created () {
    this.selected = this.value
    this.initType()
  },
  methods: {
    initType () {
      for (let index = 0; index < this.data.length; index++) {
        const element = this.data[index]
        if (this.types.indexOf(element.value) === -1) {
          element.disabled = true
        } else {
          element.disabled = false
        }
      }
    },
    checkType (item) {
      if (item.disabled) {
        return false
      }
      this.selected = item.value
      this.$emit('change', item.value)
    }
  }
}
</script>

<style scoped lang="scss">
.record_type {
  padding: 15px 30px;
  display: flex;
  flex-wrap: wrap;
  .tag {
    margin-right: 20px;
  }
}
</style>
